<template>
  <form class="form search-program" :action="endpoint" accept-charset="UTF-8" method="get">
    <checklist inputName="q[purposes_id_in][]" :items="purposes" :min-count="12"
               label-prop="name" :required="false" @change="search">
      <template #legend>留学の目的を選ぶ</template>
      <template #more>目的を全て見る</template>
    </checklist>

    <checklist inputName="q[country_id_in][]" :items="countries" :min-count="12"
               label-prop="name" :required="false" @change="search">
      <template #legend>行きたい国を選ぶ</template>
      <template #more>国を全て見る</template>
    </checklist>

    <selection inputName="q[program_courses_period_lteq]"
               :items="terms" label-prop="text"
               :required="false" @change="search">
      <template #legend>期間を選ぶ</template>
    </selection>

    <twin-selection
        :inputNames="['q[program_courses_cost_min]', 'q[program_courses_cost_max]']"
        :items="costs" label-prop="text"
        :required="false" @change="search"
        :labels="['予算(下限)', '予算(上限)']"
      >
      <template #legend>予算を選ぶ</template>
    </twin-selection>

    <selection inputName="q[program_ages_age_id_eq]"
               :items="ages" label-prop="name" value-prop="id"
               :required="false" @change="search">
      <template #legend>年代を選ぶ</template>
    </selection>

    <checklist inputName="q[program_categories_id_in][]" :items="categories" :min-count="Infinity"
               label-prop="name" :required="false" @change="search" >
      <template #legend>こだわり条件を選ぶ</template>
    </checklist>

    <p class="result" v-if="!loading">該当プログラム:{{ count }}件</p>
    <div class="loader" v-if="loading">
      <img src="../assets/images/program/loader.gif" alt="loader">
    </div>

    <button class="submit" type="submit">この条件で検索する</button>
  </form>
</template>

<script>
import TwinSelection from '@/form/twin_selection'
import Checklist from '@/form/checklist'
import Selection from '@/form/selection'
import axios from 'axios'

export default {
  components: {
    TwinSelection,
    Checklist,
    Selection
  },

  props: [
    'endpoint'
  ],

  data: function () {
    return {
      countries: [],
      purposes: [],
      terms: [],
      costs: [],
      ages: [],
      categories: [],
      count: 0,
      loading: false
    }
  },

  created: function () {
    const self = this

    axios.get('/programs.json')
      .then((res) => {
        const data = res.data

        self.countries = data.countries
        self.purposes = data.purposes
        self.terms = data.term_collection
        self.costs = data.cost_collection
        self.ages = data.ages
        self.categories = data.categories
        self.count = data.count
      })
  },

  methods: {
    search: function () {
      const self = this

      // form element
      const form = this.$el
      const formData = new FormData(form)

      // get parameter の形式にする
      const paramsSerializer = (params) => {
        return params
          .reduce((accumulator, current) => {
            accumulator.push(current.join('='))
            return accumulator
          }, [])
          .sort()
          .reduce((accumulator, current) => {
            if (accumulator.length === 0) {
              return current
            } else {
              return [accumulator, current].join('&')
            }
          }, '')
      }

      // フォームの入力値を入れる
      const params = []
      self.loading = true

      for (const entry of formData.entries()) {
        const name = entry[0]
        const value = entry[1]

        params.push([name, value])
      }

      axios.get(this.endpoint + '.json', {
        params,
        paramsSerializer
      }).then((res) => {
        const data = res.data
        self.count = data.count
        self.loading = false
      })
    }
  }
}
</script>
